import React, { useEffect, useState } from 'react'
import styles from '../../assets/stylesheets/pages/tools/tools.module.scss'
import ProjectTitle from '../../components/common/ProjectTitle';
import FormInput from "../../uicomponents/form-input/forminput";
import FutworkButton from "../../uicomponents/button/Button";
import ApiActions from '../../actions/ApiActions'
import ThreeDotLoader from '../../components/utilities/ThreeDotLoader';
import handleErrorMessage from '../../helper/handleErrorMessage';

const KycReset = (props) => {
    const [inputValue, setInputValue] = useState('')
    const [agentData, setAgentData] = useState({
        data: '',
        loading: false
    })
    const [apiResponse, setApiResponse] = useState({
        status: '',
        msg: '',
        loading: false
    })
    const [errorMsg, setErrorMsg] = useState({
       input_value: ''
    })

    const isNumeric = (str) => {
        if (typeof str != "string") return false
        return !isNaN(str) && !isNaN(parseFloat(str))
    }

    const capitalizeFirstLetter = (str) => {
        if (!str || typeof str !== 'string') return ''
        return str.charAt(0).toUpperCase() + str.slice(1)
    }

    const checkIfValid = () => {
        let validationErrors = {};
        if (inputValue.length !== 10 || !isNumeric(inputValue)) {
            validationErrors['input_value'] = 'Please enter a valid 10 digit mobile number'
        }
        if (Object.keys(validationErrors).length > 0) {
            setErrorMsg(validationErrors);
            setAgentData({data: '', loading: false})
            return false;
        } else {
            return true
        }
    }

    const getDetails = (keepApiResponse = false) => {
        setAgentData({
            data: '', loading: true
        })
        if (!keepApiResponse) {
            setApiResponse({
                status: '',
                loading: false,
                msg: ''
            })
        }
        ApiActions.getAgentDetails(inputValue)
            .then(caller => {
                setAgentData({
                    data: caller,
                    loading: false
                })
            })
            .catch(err => {
                const { data, status } = err.response || {}
                setAgentData({
                    data: '', loading: false
                })
                setApiResponse({
                    status,
                    loading: false,
                    msg: handleErrorMessage(data) || 'User not found'
                })
            })
    }

    const handleReset = (type) => {
        const typeLabel = type === 'pan' ? 'PAN' : 'Aadhaar';
        if (!window.confirm(`Are you sure you want to reset ${typeLabel} details for mobile number ${inputValue}?`)) {
            return;
        }

        setApiResponse({
            status: '',
            msg: '',
            loading: true
        })

        ApiActions.resetKYC({
            mobile: inputValue,
            type: type
        })
        .then(resp => {
            setApiResponse({
                status: 200,
                loading: false,
                msg: (resp.data && resp.data.msg) || `${typeLabel} Details reset successfully`
            })
            // Re-fetch details to show updated values and keep success message
            getDetails(true);
        })
        .catch(err => {
            const { data, status } = err.response || {}
            setApiResponse({
                status: status || 400,
                loading: false,
                msg: (data && data.msg) || `Failed to reset ${typeLabel} details`
            })
        })
    }

    return (
        <div className='container'>
            <div className={styles.coupon_code_wrapper}>
                <ProjectTitle title={`Back`} goBack={() => props.history.push("/tools")} />
                <div className={styles.title_row}>Reset KYC Tool</div>

                <div className={styles.crud_box}>
                    <div className={styles.crud_form}>
                        <div className={styles.search_row}>
                            <FormInput
                                label="Agent Mobile Number"
                                helperIcon={true}
                                helperText={'Search for an agent using their mobile number'}
                                key='mob_num'
                                value={inputValue}
                                placeholder="Enter 10 digit number & hit Enter key or hit the 'Search' button"
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                                    if (errorMsg['input_value']) {
                                        setErrorMsg(prevErrors => ({
                                            ...prevErrors,
                                            ['input_value']: null
                                        }));
                                    }
                                    setInputValue(value)
                                    if (value == '') {
                                        setAgentData({
                                            data: '',
                                            loading: false
                                        })
                                        setApiResponse({
                                            status: '',
                                            msg: '',
                                            loading: false
                                        })
                                    }
                                }}
                                onKeyUp={(event) => {
                                    if (event.key === 'Enter') {
                                        if(checkIfValid())
                                            getDetails()
                                    }
                                }}
                            />
                            <FutworkButton 
                                buttonStyle="primary--solid" 
                                disabled={inputValue.length !== 10}
                                onClick={() => {
                                    if(checkIfValid())
                                        getDetails()
                                }}
                            >
                                SEARCH
                            </FutworkButton>
                        </div>

                        {agentData.loading ? (
                            <div className={styles.agent_details}>
                                <h4 className={styles.text_center}>Agent details</h4>
                                <ThreeDotLoader />
                                <p className={styles.text_center}>Fetching agent information..</p>
                            </div>
                        ) : (
                            agentData.data && (
                                <div className={styles.agent_details}>
                                    <h4 className={styles.text_center}>Agent details</h4>

                                    <div className={styles.kyc_user_row}>
                                        <div>Name: {agentData.data.firstname} {agentData.data.lastname}</div>
                                        <div>Email: {agentData.data.email} </div>
                                        <div>Mobile: {agentData.data.mobile} </div>
                                        <div>
                                            Aadhaar KYC: <strong>{capitalizeFirstLetter(agentData.data.aadharKyc && agentData.data.aadharKyc.status) || 'Not available'}</strong>
                                        </div>
                                        <div>
                                            PAN KYC: <strong>{capitalizeFirstLetter(agentData.data.panKYCStatus) || 'Not available'}</strong>
                                        </div>
                                        <div></div>
                                    </div>

                                    <div className={styles.kyc_actions}>
                                        <FutworkButton 
                                            buttonStyle="primary--solid" 
                                            disabled={apiResponse.loading}
                                            onClick={() => handleReset('pan')}
                                        >
                                            RESET PAN
                                        </FutworkButton>
                                        <FutworkButton 
                                            buttonStyle="primary--solid" 
                                            disabled={apiResponse.loading}
                                            onClick={() => handleReset('aadhaar')}
                                        >
                                            RESET AADHAAR
                                        </FutworkButton>
                                    </div>
                                </div>
                            )
                        )}

                        {apiResponse.msg && (
                            <div className={apiResponse.status == 200 ? `${styles['success-msg']} ${styles['text_center']}` : `${styles['error-msg']} ${styles['text_center']}`}>
                                {apiResponse.msg}
                            </div>
                        )}
                        {errorMsg && errorMsg.input_value ? (
                            <div className={`${styles['error-msg']} ${styles['text_center']}`}>{errorMsg.input_value}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default KycReset
